export const examAdminReview = {
  pageTitle: "Review Center",
  pageSubtitle:
    "AI pre-review plus manual final review, focused first on short-answer review flows.",
  summary: {
    pending: "Pending review items: {count}",
    shortAnswer: "Short answers: {count}",
    aiReviewed: "AI pre-reviewed: {count}",
  },
  actions: {
    aiReviewShortAnswer: "AI Pre-review Short Answers",
    goReview: "Review",
    submitScore: "Submit Score",
  },
  messages: {
    scoreSubmitted: "Review score submitted",
    aiReviewCompleted: "AI pre-review completed: {success} succeeded, {failed} failed",
  },
  notices: {
    aiReviewHint:
      "AI pre-review only generates suggested scores. Final subjective scores are set after manual/review submission.",
  },
  drawers: {
    manualReviewTitle: "Manual Review",
    manualReviewTitleWithId: "Manual Review #{id}",
  },
  fields: {
    score: "Score",
    comment: "Comment",
    commentPlaceholder: "Enter review notes or scoring rationale",
    detailJson: "detail_json",
  },
  labels: {
    notReviewed: "Not pre-reviewed",
    stem: "Stem",
    aiSummary: "AI Pre-review Summary",
    suggestedScore: "Suggested score: {score}",
    context: "Context",
    aiHits: "AI Hits",
  },
  table: {
    attemptQuestion: "Attempt Question",
    examId: "Exam ID",
    questionId: "Question ID",
    questionType: "Question Type",
    title: "Title",
    aiReview: "AI Pre-review",
    actions: "Actions",
  },
} as const;
